<template>
	<div>
		<v-card class="sidebar-menu-item" :to="menuItemToPresent.path">
			<v-layout justify-space-between align-center>
				<div>
					<div class="menu_item_name">{{ getStateWithParam(menuItemToPresent.name) }}</div>
				</div>
				<div>
					<div class="image_avatar">
						<v-avatar>
							<img v-bind:src="menuItemToPresent.image" alt>
						</v-avatar>
					</div>
				</div>
			</v-layout>
		</v-card>
	</div>
</template>

<script>
export default {
	props: {
		menuItemToPresent: {
			type: Object,
			required: true
		}
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		}
	}
};
</script>

<style  lang="scss" scoped>
.sidebar-menu-item {
	margin-bottom: 15px;
	border-radius: 10px;
	height: 50px;
	box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
	padding: 0 15px;
}
.router-link-active,
.router-link-exact-active {
  	box-shadow: 0 3px 5px 0px rgba(0, 0, 0, 0.5);
}

.menu_item_name {
  	font-weight: 600;
}
</style>